import { Employee } from '../Employee';

export enum M0150ContactCardBigType {
    A = 'a'
}

export interface M0150ContactCardBig extends Employee {
    type: string;
}
